import {HStack, Heading, Icon, Show} from 'platform/foundation';

import {isNotEmpty} from 'ramda';

import {OrderResponseBody} from '@dms/api/finance';
import i18n from '@dms/i18n';

import {Nullish, TestIdProps} from 'shared/web';

import {CorrectiveTaxDocumentPayment} from './CorrectiveTaxDocumentPayment/CorrectiveTaxDocumentPayment';

interface CorrectiveTaxDocumentPaymentListProps extends TestIdProps {
  order: OrderResponseBody;
  taxDocument:
    | {
        orderId: string;
        paymentId: string;
        taxDocumentId: string;
        taxDocumentType: string;
      }[]
    | Nullish;
  checkoutId: string;
}

export function CorrectiveTaxDocumentPaymentList(props: CorrectiveTaxDocumentPaymentListProps) {
  const currentOrderDocuments =
    props.taxDocument?.filter(
      (document) =>
        document.orderId === props.order.id &&
        document.taxDocumentType === 'corrective-tax-document'
    ) ?? [];

  return (
    <Show when={isNotEmpty(currentOrderDocuments)}>
      <HStack spacing={2} align="center">
        <Icon value="editor/insert_drive_file" />
        <Heading size={4}>{i18n.t('entity.accounting.labels.correctiveTaxDocuments')}</Heading>
      </HStack>

      {currentOrderDocuments.map((document) => (
        <CorrectiveTaxDocumentPayment
          order={props.order}
          key={`${document.taxDocumentId}-${document.taxDocumentType}`}
          correctiveTaxDocumentId={document.taxDocumentId}
          paymentId={document.paymentId}
          checkoutId={props.checkoutId}
          data-testid={props['data-testid']}
        />
      ))}
    </Show>
  );
}
